<template>
  <div class="w-100">
    <div v-if="isLoading" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <div v-if="generalError" class="py-3">
        <ErrorMessage :message="generalError" />
      </div>
      <template v-else>
        <p class="mb-3 body-1-4">Shipped From</p>
        <div class="w-100">
          <!-- Merchant Location -->
          <div class="d-flex align-items-center">
            <div class="flex-shrink-0 mr-3">
              <svg width="30" height="auto" viewBox="0 0 40 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.9704 20.8801C7.90252 20.8801 9.59094 19.9963 10.6527 18.5928C11.6971 19.9963 13.3855 20.8801 15.3177 20.8801C17.2672 20.8801 18.9556 19.9963 19.9999 18.5928C21.0444 19.9963 22.7328 20.8801 24.6823 20.8801C26.6319 20.8801 28.3029 19.9963 29.3646 18.5928C30.4091 19.9963 32.0975 20.8801 34.0296 20.8801C37.3717 20.8801 40 18.2636 40 14.9713V14.6767C40 14.0009 39.8259 13.3944 39.4777 12.8053L34.8651 4.95577V3.51756C34.8651 1.31692 33.5074 0 31.262 0H8.75543C6.51 0 5.1349 1.31692 5.1349 3.51756V4.95577L0.522192 12.8053C0.174065 13.3944 0 14.0009 0 14.6767V14.9713C0 18.2636 2.62837 20.8801 5.9704 20.8801ZM7.76326 4.41861V4.00274C7.76326 3.13634 8.26806 2.61651 9.12096 2.61651H30.8791C31.732 2.61651 32.2367 3.13634 32.2367 4.00274V4.41861H7.76326ZM3.01131 13.6544L6.7885 7.03511H33.0722L36.9538 13.6544H3.01131ZM2.61096 16.0976H9.32985C8.94691 17.5011 7.76326 18.4369 5.9704 18.4369C4.17754 18.4369 2.9939 17.5011 2.61096 16.0976ZM11.9756 16.0976H18.6771C18.2941 17.5011 17.1105 18.4369 15.3177 18.4369C13.5422 18.4369 12.3412 17.5011 11.9756 16.0976ZM21.3229 16.0976H28.0418C27.6588 17.5011 26.4752 18.4369 24.6823 18.4369C22.8895 18.4369 21.7058 17.5011 21.3229 16.0976ZM30.6876 16.0976H37.3891C37.0061 17.5011 35.8225 18.4369 34.0296 18.4369C32.2541 18.4369 31.053 17.5011 30.6876 16.0976ZM6.91035 37.9827H33.0896C35.5613 37.9827 37.0061 36.5792 37.0061 34.1533V19.4418L34.2036 19.5459V33.4428C34.2036 34.5691 33.6118 35.1929 32.4978 35.1929H7.51958C6.40557 35.1929 5.79634 34.5691 5.79634 33.4428V19.5285L2.9939 19.4939V34.1533C2.9939 36.5792 4.43864 37.9827 6.91035 37.9827ZM8.56396 36.8391H18.6074V25.472C18.6074 24.6749 18.0853 24.155 17.2846 24.155H9.90426C9.10357 24.155 8.56396 24.6749 8.56396 25.472V36.8391ZM21.8799 24.5536V29.4401C21.8799 30.2544 22.402 30.757 23.2202 30.757H30.2872C31.0879 30.757 31.5926 30.2544 31.5926 29.4401V24.5536C31.5926 23.7392 31.0879 23.2366 30.2872 23.2366H23.2202C22.402 23.2366 21.8799 23.7392 21.8799 24.5536Z"
                  class="fill-primary" />
              </svg>
            </div>
            <div class="w-100 text-truncate d-block">
              <p class="mb-0 body-2-4 text-truncate">{{ getMerchant.name }}</p>
              <p class="mb-0 body-3">{{ summary.distance }}</p>
              <p v-if="this.$isNotEmptyV2(this.getRestaurantDelivery.detail)" class="mb-0 body-3">{{ summary.time }}</p>
            </div>
          </div>
    
          <!-- Line -->
          <div class="w-100" style="padding-left: 14px;">
            <div class="w-100" style="height: 30px;border-left: 3px dotted #7C7C7C !important;"></div>
          </div>
    
          <!-- Guest Locations -->
          <div @click="toggleDetailForm" class="d-flex align-items-center justify-content-between mb-4">
            <div class="">
              <svg width="30" height="auto" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14.7368 10.8064C14.7368 9.43255 13.6236 8.31934 12.2507 8.31934C10.8769 8.31934 9.76367 9.43255 9.76367 10.8064C9.76367 12.1792 10.8769 13.2924 12.2507 13.2924C13.6236 13.2924 14.7368 12.1792 14.7368 10.8064Z"
                  stroke="#d9534f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.2498 21.25C12.2498 21.25 4.97391 16.5108 4.79058 10.5973C4.66185 6.4451 8.12963 2.75008 12.2498 2.75008C16.3699 2.75008 19.8368 6.44504 19.7099 10.5973C19.5255 16.632 12.2498 21.25 12.2498 21.25Z"
                  stroke="#d9534f" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
            <div class="w-100 text-truncate px-3 d-block">
              <p class="mb-0 body-2-4 text-truncate">{{ summary.destinationTitle }}</p>
              <p class="mb-0 body-3 text-truncate">{{ summary.destinationSubtitle }}</p>
              <p v-if="$isNotEmptyV2(summary.landmark)" class="mb-0 body-3">Address Detail : {{ summary.landmark }}</p>
            </div>
            <button class="g-btn g-btn-primary-outline g-btn-sm">
              {{ summary.needSetup ? 'Setup' : 'Edit' }}
            </button>
          </div>
        </div>

        <popup-detail
          direction="bottom" 
          :show="showForm"
          use_max_size
          title="Address Detail"
          wrapper_size="mobile"
          :use_footer="showFooterForm"
          :no_close_backdrop="noCloseBackdrop"
          @close="toggleDetailForm">

          <template v-slot:body>
            <SetupAddress 
              v-if="showForm" 
              ref="setupAddress" 
              :default-data="detailAddress"
              address-only
              @show-footer="toggleFooterForm"
              @no-close-backdrop="toggleNoCloseBackdropForm"
            /> 
            <div class="px-4 pb-4" v-if="userSavedAddress.list.length > 0 && userSavedAddress.isLoading === false && showFooterForm">
              <div class="p-3 radius-12 bg-white box-shadow-light-aff border-form">
                <p class="mb-3 body-1-4">Select from saved address</p>
                <div class="w-100 mb-3" v-if="userSavedAddress.errorSelect != ''">
                  <ErrorMessage :message="userSavedAddress.errorSelect" />
                </div>
                <div v-if="userSavedAddress.isLoading" class="w-100 py-4 text-center">
                  <loader />
                </div>
                <template v-else>
                  <div v-for="(addressItem, addressIndex) in userSavedAddress.list":class="{'pb-3 mb-3 border-b-form-dashed-2' : addressIndex+1 < userSavedAddress.list.length}">
                    <p class="mb-1 body-2-4 w-100 text-truncate">{{ addressItem.title }}</p>
                    <p class="body-3-3 mb-2">{{ addressItem.full_address }}</p>
                    <state-button size="sm" primary="secondary-outline" :click="selectUserSavedAddress" :data="{ addressDetail : addressItem}">Select this Address</state-button>
                  </div>
                </template>
              </div>
            </div>
          </template>
          
          <template v-slot:footer>
            <div class="p-4 border-t-form">
              <p v-if="pushError != ''" class="mb-2 body-2-4 text-danger w-100 text-center">{{ pushError }}</p>
              <state-button
                :click="submitAddress" 
                size="lg"
                variant="primary"
                block >
                Save Address
              </state-button>
            </div>
          </template>
        </popup-detail>
      </template>
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import { post, get } from "@/services/index.js";
  import SetupAddress from './SetupAddress.vue';

  export default {
    components:{
      SetupAddress
    },
    data(){
      return{
        isLoading: true,
        generalError: "",
        showForm: false,
        showFooterForm: false,
        noCloseBackdrop: false,
        pushError: "",
        detailAddress: {},
        userSavedAddress: {
          isLoading: false,
          list: [],
          errorSelect: ''
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getRestaurantDelivery', 'isLoggedIn']),
      summary(){
        let text = {
          needSetup: true,
          distance: 'Set the delivery address first',
          time: '',
          destinationTitle: 'Delivery Address',
          destinationSubtitle: 'Click here to set your delivery address.',
          landmark: ""
        }
        
        if(this.$isEmpty(this.getRestaurantDelivery.detail)) return text;
        const { savedAddress, distance_text, duration_text, shortName, destination_text, landmark	 } = this.getRestaurantDelivery.detail 

        text = {
          needSetup: false,
          distance: `${distance_text} from your location`,
          time: `Estimated delivery time : ${duration_text}`,
          destinationTitle: this.$isNotEmptyV2(savedAddress) ? savedAddress.title : shortName,
          destinationSubtitle: destination_text,
          landmark: this.$isNotEmptyV2(savedAddress) ? savedAddress.address : landmark
        }
        return text;
      }
    },
    mounted(){
      this.setupPage();
    },
    methods:{
      ...mapMutations(['setRestaurantDeliveryDetail', 'setRestaurantDeliverySavedAddressId']),
      async setupPage() {
        try {
          this.isLoading = true;
          this.generalError = "";

          const hasSavedRestaurantData = this.$isNotEmptyV2(this.getRestaurantDelivery.detail);
          if (hasSavedRestaurantData) {
            await this.handleSavedRestaurantData();
            return;
          }

          await this.handleNewUserData();
        } catch (error) {
          this.errorMessage = error.message;
        } finally {
          this.isLoading = false;
        }
      },
      async handleSavedRestaurantData() {
        const { savedAddressId, detail: { latitude, longitude, landmark="" } } = this.getRestaurantDelivery;
        
        if (this.$isEmpty(savedAddressId)) {
          await this.updateSavedAddressDetail(latitude, longitude, landmark);
          return;
        }

        const savedAddressDetail = this.isLoggedIn ? await this.getDetailSavedAddress(savedAddressId) : null;
        if(this.$isEmpty(savedAddressDetail)) this.setRestaurantDeliverySavedAddressId(null);

        await this.updateSavedAddressDetail(latitude, longitude, savedAddressDetail, landmark);
      },
      async handleNewUserData() {
        if (this.isLoggedIn) {
          const savedAddressList = await this.getListSavedAddress();
          if (this.$isNotEmptyV2(savedAddressList)) {
            await this.useSavedAddress(savedAddressList[0]);
            return;
          }
        }
        await this.useCurrentLocation();
      },
      async useSavedAddress(savedAddress) {
        const { id, latitude, longitude, address } = savedAddress;
        this.setRestaurantDeliverySavedAddressId(id);
        await this.updateSavedAddressDetail(latitude, longitude, savedAddress, address);
      },
      async useCurrentLocation() {
        const currentLocation = await this.getCurrentLocationApi();
        if (this.$isNotEmptyV2(currentLocation)) {
          await this.updateSavedAddressDetail(currentLocation.latitude, currentLocation.longitude);
        }
      },
      async getDetailSavedAddress(savedAddressId){
        try {
          const apiResponse = await get("CORE_RESTO", `shipping-address/${savedAddressId}`);
          const { success, data, message } = apiResponse.data;
          if(!success) throw new Error(message);
          return this.$isEmpty(data) ? null : data;   
        } catch (error) {
          console.log("ERROR in getDetailSavedAddress() : ", error.message);
          return null;
        }
      },
      async updateSavedAddressDetail(latitude, longitude, savedAddress=null, landmark=""){
        try {
          const updatedDetailAddress = await this.getDetailDelivery(latitude, longitude);
          const getShortNameAddress =  await this.getShortNameAddress(latitude, longitude);
          
          this.setRestaurantDeliveryDetail({
            ...updatedDetailAddress,
            shortName: getShortNameAddress,
            landmark,
            savedAddress
          });
        } catch (error) {
          throw error;
        }
      },
      async getDetailDelivery(lat,long){
        try {

          const apiParams = { lat, long, merchant_id : this.getMerchant.id }
          const apiResponse = await post("CORE_RESTO", "v2/delivery-fee", apiParams);
          const { success, message, data } =  apiResponse.data

          if(!success) throw new Error(message);
          
          return data;
        } catch (error) {
          throw error;
        }
      },
      async getShortNameAddress(lat,long){
        try {
          const apiResponse = await get("CORE", "user-location", { lat, long });
          const { success, message, data } =  apiResponse.data
          if(!success) throw new Error(message);
          return this.getValidShortName(data.address_components);
        } catch (error) {
          throw error;
        }
      },
      getValidShortName(addressComponents) {
        for (const component of addressComponents) {
          if (!component.types.includes("plus_code") && component.short_name) {
            return component.short_name;
          }
        }
        return "-";
      },
      async getListSavedAddress(){
        try {
          const apiResponse = await get("CORE_RESTO", "shipping-address");
          const { success, message, data } =  apiResponse.data;
          if(!success) throw new Error(message);
          return data;
        } catch (error) {
          throw error;
        }
      },
      getCurrentLocationApi(){
        return new Promise((resolve, reject) => {
          if(!navigator.geolocation) resolve(null);
          navigator.geolocation.getCurrentPosition(
            (position) => resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude }),
            (error) => resolve(null),
            { enableHighAccuracy: true, maximumAge: 0 }
          );
        });
      },

      // FORM DETAIL
      toggleDetailForm(){
        this.showForm = !this.showForm;
        if(this.showForm){
          if(!this.summary.needSetup){
            const { destination_position , landmark } = this.getRestaurantDelivery.detail
            this.detailAddress = { latitude: destination_position[0], longitude: destination_position[1], address: landmark }
          }
          if(this.isLoggedIn) this.getUserSavedAddress()
        }else{
          this.detailAddress = {}
        }
      },
      toggleFooterForm(show){
        this.showFooterForm = show
      },
      toggleNoCloseBackdropForm(show){
        this.noCloseBackdrop = show
      },
      async submitAddress(){
        try {

          const formData = await this.$refs.setupAddress.submitForm();
          if(this.$isEmpty(formData)) {
            this.toggleNoCloseBackdropForm(false)
            return Promise.resolve()
          };
          const { latitude, longitude, landmark } = formData

          const {detail, savedAddressId} = this.getRestaurantDelivery;
          let savedAddress = null
          if(this.$isNotEmptyV2(savedAddressId)){
            const isPositionChange = latitude !== detail.destination_position[0] || longitude !== detail.destination_position[1]
            if(isPositionChange) this.setRestaurantDeliverySavedAddressId(null);
            else savedAddress = detail.savedAddress
          }
          
          
          await this.updateSavedAddressDetail(latitude, longitude, savedAddress, landmark)
          this.toggleDetailForm();
        } catch (error) {
          this.pushError = error.message;
        } finally {
          Promise.resolve();
        }
      },
      async getUserSavedAddress(){
        try {
          this.userSavedAddress.isLoading = true
          
          const apiResponse = await get("CORE_RESTO", "shipping-address");
          const { success, data, message } = apiResponse.data
          if(!success) throw new Error(message);
          
          this.userSavedAddress.list = await Promise.all(
            data.map(async (item) => {
              const detailDelivery = await this.getDetailDelivery(item.latitude, item.longitude);
              item.full_address = detailDelivery.destination_text	
              return item;
            })
          );
        } catch (error) {
          console.log("ERROR > getUserSavedAddress() : ", error.message);
        } finally {
          this.userSavedAddress.isLoading = false
        }
      },
      async selectUserSavedAddress({addressDetail}){
        try {
          this.userSavedAddress.errorSelect = ""
          const { id, latitude, longitude, address } = addressDetail
          this.setRestaurantDeliverySavedAddressId(id)
          await this.updateSavedAddressDetail(latitude, longitude, addressDetail, address)
          this.toggleDetailForm()
        } catch (error) {
          this.userSavedAddress.errorSelect = error.message
        } finally {
          return Promise.resolve();
        }
      }
      
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/general/DeliveryDetail.vue